function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { buttonSendsAnalytics } from '../flags';
import { defaultAnalyticsFunction, EventCategory, EventType, getAnalyticsContentFromRefs, eventExtensionText } from '../analytics';
import { useRef } from 'react';
export default function useButtonAnalytics(_ref) {
  var analytics = _ref.analytics,
    analyticsLabelOverride = _ref.analyticsLabelOverride,
    analyticsParentHeading = _ref.analyticsParentHeading,
    analyticsParentType = _ref.analyticsParentType,
    href = _ref.href,
    _ref$onAnalyticsEvent = _ref.onAnalyticsEvent,
    onAnalyticsEvent = _ref$onAnalyticsEvent === void 0 ? defaultAnalyticsFunction : _ref$onAnalyticsEvent,
    type = _ref.type,
    variation = _ref.variation;
  var contentRef = useRef();
  function sendButtonEvent() {
    if (analytics !== true && (!buttonSendsAnalytics() || analytics === false)) {
      return;
    }
    var buttonText = analyticsLabelOverride !== null && analyticsLabelOverride !== void 0 ? analyticsLabelOverride : getAnalyticsContentFromRefs([contentRef]);
    var buttonStyle = variation !== null && variation !== void 0 ? variation : 'default';
    var buttonType = type !== null && type !== void 0 ? type : 'button';
    var buttonParentHeading = analyticsParentHeading !== null && analyticsParentHeading !== void 0 ? analyticsParentHeading : ' ';
    var buttonParentType = analyticsParentType !== null && analyticsParentType !== void 0 ? analyticsParentType : ' ';
    return onAnalyticsEvent(_objectSpread({
      event_name: 'button_engagement',
      event_type: EventType.UI_INTERACTION,
      event_category: EventCategory.UI_INTERACTION,
      event_action: "engaged ".concat(buttonStyle, " button"),
      event_label: href ? "".concat(buttonText, ": ").concat(href) : buttonText,
      event_extension: eventExtensionText,
      text: buttonText,
      button_style: buttonStyle,
      button_type: href ? 'link' : buttonType,
      parent_component_heading: buttonParentHeading,
      parent_component_type: buttonParentType
    }, href ? {
      link_url: href
    } : {}));
  }
  return {
    contentRef: contentRef,
    sendButtonEvent: sendButtonEvent
  };
}